import { Phone, MessageSquare } from "lucide-react";

/**
 * Sticky mobile call/enquire bar. ~60% of traffic is mobile and the
 * primary conversion action (a phone call) was previously only visible
 * at the very top of the page.
 */
const MobileCTABar = () => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t border-white/10 bg-foreground/95 backdrop-blur-md">
      <a
        href="tel:+15598719051"
        className="flex items-center justify-center gap-2 py-4 text-sm font-semibold text-primary-foreground bg-primary"
      >
        <Phone className="h-4 w-4" />
        Call (559) 871-9051
      </a>
      <a
        href="#contact"
        className="flex items-center justify-center gap-2 py-4 text-sm font-semibold text-white"
      >
        <MessageSquare className="h-4 w-4" />
        Get Free Advice
      </a>
    </div>
  );
};

export default MobileCTABar;
